/**
 * @file index.tsx
 *
 * @fileoverview Renders button for sharing on Facebook.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import FacebookColorIcon from '~/vcl/icons/color/Facebook';
import { FormattedMessage } from 'react-intl';
import FacebookIcon from '~/vcl/icons/Facebook';

export default function FacebookSharingButton({
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_facebook"
          defaultMessage="on Facebook"
        />
      }
      urlToShare={url}
      href="https://facebook.com/sharer/sharer.php?u="
      IconComponent={coloredIcons ? FacebookColorIcon : FacebookIcon}
      {...props}
    />
  );
}
export { FacebookSharingButton };
